module.exports = __webpack_public_path__ + "img/aztec_1920.a3e6314d.png";